import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config';

function UhcExclusions({ fetchWithAuth }) {
  const [exclusions, setExclusions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadExclusions();
  }, []);

  const loadExclusions = async () => {
    setLoading(true);
    try {
      const res = await fetchWithAuth(`${API_BASE}/api/uhc/exclusions`);
      if (res.ok) {
        const data = await res.json();
        setExclusions(data.exclusions || []);
      }
    } catch (err) {
      console.error('Failed to load UHC exclusions:', err);
    }
    setLoading(false);
  };

  const handleClear = async (exclusion) => {
    try {
      const res = await fetchWithAuth(`${API_BASE}/api/uhc/exclusions/${exclusion.id}/clear`, {
        method: 'DELETE',
      });
      if (res.ok) {
        loadExclusions();
      }
    } catch (err) {
      console.error('Failed to clear record:', err);
    }
  };

  const handleClearAll = async () => {
    for (const exc of exclusions) {
      await handleClear(exc);
    }
  };

  if (loading) {
    return <div className="card"><p>Loading...</p></div>;
  }

  return (
    <div className="uhce-container">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Auto-Excluded Records</h3>
        </div>
        <div className="uhce-explainer">
          <p>
            The UHC Auditor automatically excludes records that contain invalid or garbage data
            (hash IDs, placeholder values, empty content, duplicates). These records are removed
            from your AI health context to prevent inaccurate recommendations.
          </p>
          <p>
            Click <strong>Clear</strong> to permanently delete an individual record,
            or <strong>Clear All</strong> to delete all excluded records at once.
          </p>
          {exclusions.length > 0 && (
            <button className="btn btn-primary" onClick={handleClearAll} style={{marginTop: 8}}>
              Clear All ({exclusions.length})
            </button>
          )}
        </div>

        {exclusions.length === 0 ? (
          <p className="uhce-emptyState">
            No records have been excluded. Your UHC data is clean.
          </p>
        ) : (
          <div className="uhce-list">
            <div className="uhce-listHeader">
              <span className="uhce-countBadge">{exclusions.length} excluded</span>
            </div>
            {exclusions.map((exc) => (
              <div key={exc.id} className="uhce-recordItem uhce-recordItem--excluded">
                <div className="uhce-recordInfo">
                  <span className="uhce-recordTitle">{exc.record_title || 'Untitled'}</span>
                  <span className="uhce-recordType">{exc.record_type}</span>
                  {exc.reason && (
                    <span className="uhce-excludeReason">Reason: {exc.reason}</span>
                  )}
                  {exc.created_at && (
                    <span className="uhce-recordDate">
                      Excluded {new Date(exc.created_at).toLocaleDateString()}
                    </span>
                  )}
                </div>
                <div className="uhce-recordActions">
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={() => handleClear(exc)}
                  >
                    Clear
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default UhcExclusions;
